import { useQuery, useQueryClient } from "@tanstack/react-query"
import { getConciliacionBancariaById } from "./ConciliacionBancaria.service"

export const useConciliacionBancariaId = (id?: string | null) => {
  const queryClient = useQueryClient()
  const {
    data: conciliacionBancariaById,
    error: conciliacionBancariaByIdError,
    isLoading: conciliacionBancariaByIdIsLoading,
    refetch: conciliacionBancariaByIdRefetch,
  } = useQuery({
    queryKey: ["getConciliacionBancariaById", id],
    enabled: Boolean(id),
    queryFn: () => getConciliacionBancariaById(id ?? ""),
    refetchOnWindowFocus: false,
    retry: false,
    retryOnMount: false,
  })

  const conciliacionBancariaByIdInvalidation = () =>
    queryClient.invalidateQueries({ queryKey: ["getConciliacionBancariaById"] })

  return {
    conciliacionBancariaById,
    conciliacionBancariaByIdError,
    conciliacionBancariaByIdIsLoading,
    conciliacionBancariaByIdRefetch,
    conciliacionBancariaByIdInvalidation,
  }
}
